import React, { Fragment, useEffect, useState } from "react";
import { set_users } from "../../../redux/actions/UsersAction";
import { set_vendor_store } from "../../../redux/actions/StoreAction";
import { connect } from "react-redux";
import { set_loading } from "../../../redux/actions/LayoutAction";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import UserList from "./components/UserList";
import Header from "../subheader/Header";
import AccountDetail from "./components/AccountDetail";
import { Link, useLocation } from "react-router-dom";
import "./profile.scss";

const Profile = (props) => {
  const location = useLocation();
  const [data, setData] = useState(false);
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    document.title = "Profile";
    apiJson.profile.getUsers(1).then((response) => {
      if (response.success) {
        props.set_users({
          users: response.data.customers,
          pagination: response.data.pagination,
        });
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
    apiJson.vendorProfile.getVendorProfile().then((response) => {
      if (response.success) {
        props.set_vendor_store({ vendorStore: response.data });
        setData(true);
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
        setData(true);
      } else {
        setData(true);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }, []);
  const [isUserClick, setisUserClick] = useState(
    location &&
      location.state &&
      location.state.name &&
      location.state.name === "userlist"
      ? false
      : true
  );
  const classname = "button-bg";

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      <div className="vendor-page-right profile-page-desktop">
        <Header heading="Account" search={false} filters={null} />
        <div className="right-content profile-page-content">
          <div className="content-container profile-page-container">
            <div className="content-wrapper">
              <div className="header-row d-flex w-100">
                <button
                  className={
                    isUserClick ? `${classname} user-button` : "user-button"
                  }
                  onClick={() => setisUserClick(true)}
                >
                  Store Details
                </button>
                <button
                  className={
                    !isUserClick ? `${classname} users-list` : "users-list"
                  }
                  onClick={() => setisUserClick(false)}
                >
                  User List
                </button>
                <Link
                  className={
                    "user-button"
                  }
                  to="/vendor/menu"
                >
                  Menu Items
                </Link>
                <Link
                  className={
                    "user-button"
                  }
                  to="/vendor/shop-banners"
                >
                  Shop Banners
                </Link>
              </div>
              {data && (
                <div className="account-profile">
                  {isUserClick ? (
                    <AccountDetail AccountDetail={props.vendorStore} />
                  ) : (
                    <UserList AccountDetail={props.users} />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    users: state.user.users,
    vendorStore: state.vendorStore.vendorStore,
    load: state.layout.isLoading,
  };
};

const mapDispatchTopProps = { set_users, set_vendor_store, set_loading };

export default connect(mapStateToProps, mapDispatchTopProps)(Profile);
